import { useViewer } from 'ms-helpers/Viewer/Renderer';
import type { FeatureFlagsV2 } from 'ms-helpers/Viewer/ViewerProvider';

export default function useFeatureFlagsV2(): FeatureFlagsV2 {
  const { featureFlagsV2 } = useViewer();
  return featureFlagsV2;
}
